import { render, staticRenderFns } from "./generalizedReturn.vue?vue&type=template&id=f06c5f1e&scoped=true&"
import script from "./generalizedReturn.vue?vue&type=script&lang=js&"
export * from "./generalizedReturn.vue?vue&type=script&lang=js&"
import style0 from "./generalizedReturn.vue?vue&type=style&index=0&lang=less&"
import style1 from "./generalizedReturn.vue?vue&type=style&index=1&id=f06c5f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06c5f1e",
  null
  
)

export default component.exports